<template>
   <div class="container container-nav bg-gray store-detail">
      <van-nav-bar
        title="门店详情"
        fixed
        left-arrow
        :border=false
        :z-index=999
        @click-left="goBack"
      />
      <section class="bg-white txt-c store-detail-top mb10">
        <p class="img-auto"><img :src="storeUrl" alt=""></p>
        <h1 class="f18 txt-elips"><b>{{storeName}}</b></h1>
        <p class="f12 c-gray txt-elips">{{storeAddress}}</p>
      </section>

        <div>
            <h2 class="f16 van-hairline--bottom mt10"><b>在招岗位({{total}}）</b></h2>
        <van-list class="search-list" v-model="loading" :finished="finished"  :immediate-check="false" @load="getList()">
          <recruit-item v-for="(item,index) in list" :key="index" :item="item" :mapAddress="mapAddress" :showImg="false" @confirm="onConfirm"></recruit-item>
        </van-list>
      <blank-tip tip="抱歉，无匹配内容~" v-if="!showInit&&!loading&&empty===10"></blank-tip>
          </div>
    <!--  生成海报  -->
    <div id="share" style="position:fixed;right:-9999px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <info :recruit="recruitItem" :showShare="true">
        <template #shareImg>
        <div class="txt-r">
        <img :src="codeData" @load="initCanvas" @error="initCanvas" class="qr pr25 pb10"/>
      </div>
      </template>
      </info>
    </div>
    <!--  生成海报  -->
    <div id="sharesmall" style="position:fixed;right:-7777px;width:100%;top:0;">
      <div class="poster-title" style="border-radius:0">
        <img src="../../assets/images/poster/t-logo.png" class="poster-logo lb-vm"/>
      </div>
      <infosmall :recruit="recruitItem" :showShare="true">
        <template #shareSmallImg>
        <div class="txt-r">
        <img :src="codeData2" @load="initCanvas2" @error="initCanvas2" class="qr pr25 pb10"/>
      </div>
      </template>
      </infosmall>
    </div>
    <van-dialog
              v-model="show"
              title="分享到"
              show-cancel-button :showConfirmButton=false
            >
                 <van-row type="flex" justify="center" class="mt19 mb20">
                      <van-col span="9" class="txt-c" @click.native="doShare(1, `${shareId}`)">
                        <p><img class="poster-img" src="../../assets/images/poster/wx.png"/></p>
                        <p class="pt8 f12 pb10">微信</p>
                      </van-col>
                      <van-col span="9" class="txt-c" @click.native="doShare(2, `${shareId}`)">
                        <p><img class="poster-img" src="../../assets/images/poster/pyq.png"/></p>
                        <p class="pt8 f12 pb10">朋友圈</p>
                      </van-col>
                </van-row>
            </van-dialog>
   </div>
</template>

<script>
import info from '../recruit/info';
import infosmall from '../recruit/infosmall';
import api from '../../api';
import html2canvas from 'html2canvas';
import recruitItem from '../../components/recruit-item';
import blankTip from '../../components/blank-tip';
import recruit from '../../mixins/recruit';
import shop from '../../mixins/shop';
import { shareWithApp, launchMiniProgram } from '../../libs/native-app';
import { convertBase64ToBlob } from '../../libs/util';
export default {
  name: 'store-detail',
  components: { recruitItem, blankTip, info, infosmall },
  mixins: [recruit, shop],
  data() {
    return {
      show: false,
      showInit: true,
      shop: {},
      total: 0,
      empty: 0,
      shopempty: 0,
      list: [],
      loading: false,
      finished: false,
      mapAddress: null,
      canloadlist: false,
      Paging: { PageIndex: 1, PageSize: 10 },
      recruitItem: { SalaryMin: 0, SalaryMax: 0, PositionUrlList: [] },
        shareType: 0,
        shareId: null,
        codeData: null,
        codeData2: null,
        canvasData: '',
        lastScrollLength: 0,
        userName: '',
        mType: 0
    };
  },
  computed: {
    storeName() {
      return this.$route.query.name ? decodeURIComponent(this.$route.query.name) : '';
    },
    storeUrl() {
      return this.$route.query.storeUrl ? decodeURIComponent(this.$route.query.storeUrl) : '';
    },
    storeAddress() {
      return this.$route.query.address ? decodeURIComponent(this.$route.query.address) : '';
    }
  },
  mounted() {
    // 门店信息已通过URL参数传递，直接加载岗位列表
    this.canloadlist = true;
    this.getList(true);
  },
  methods: {
    async getList(init = false) {
        try {
          if (!this.canloadlist) {
            return;
          }
          if (init) this.Paging.PageIndex = 1;
          this.showInit = false;
          this.loading = true;

          let result = await this.$store.dispatch('postData', {
            url: '/api/vpai/recruit/list_by_storeId',
            data: {
              ...(this.$route.query.jobType ? { jobType: Number(this.$route.query.jobType) } : {}),
              lat: this.$store.state.pos ? this.$store.state.pos.lat : 0,
              lng: this.$store.state.pos ? this.$store.state.pos.lng : 0,
              pageNum: this.Paging.PageIndex,
              pageSize: this.Paging.PageSize,
              storeId: this.$route.query.id
            },
            need_sign: false
          });
          // 接口返回数组，直接使用新接口字段，无需映射
          let dataList = Array.isArray(result) ? result : [];
          if (init) this.list = dataList;
          else this.list = [...this.list, ...dataList];
          this.$nextTick(() => {
            this.empty = init && dataList.length === 0 ? 10 : 0;
            this.finished = dataList.length < this.Paging.PageSize;
            this.total = this.list.length;
            this.Paging.PageIndex++;
            this.loading = false;
          });
        } catch (e) {
          this.loading = false;
          this.finished = true;
          this.$error(e.message);
        }
      },
      async getRecruitBySysNo(id) {
        try {
          var findVal = this.list.find(item => {
            return (item.id * 1) === (id * 1);
          });
          this.recruitItem = findVal;
          // let json = { RecruitSysNo: id };
          // if (this.$store.state.pos) {
          //   json.Latitude = this.$store.state.pos.lat;
          //   json.Longitude = this.$store.state.pos.lng;
          // }
          // let result = await this.$store.dispatch('postData', {
          //   url: '/recruit/GetRecruitBySysNo',
          //   data: { Extra: json }
          // });
          // this.recruitItem = this.processRecruitData(result);
          // console.log(JSON.stringify(this.recruitItem));
          this.getCodeData();
        } catch (e) {
          this.$error(e.message);
        }
      },
      async getCodeData() {
        try {
          this.$loading('获取数据');
          this.codeData2 = null;
          this.codeData = null;
          const result = await api.get('/api/share/create_share_token', {
            params: {
              recruitDispatchRecordId: this.recruitItem.recruitDispatchRecordId || '',
              recruitId: this.recruitItem.id || ''
            }
          });
          // 接口返回格式：{ code: 10000, data: "token字符串" }
          let trackToken = '';
          if (result.code === 10000 && result.data) {
            trackToken = result.data;
          }
          if (this.shareType === 1) {
            this.codeData2 = trackToken;
            console.log(JSON.stringify(this.codeData2));
          } else {
            this.codeData = trackToken;
            console.log(JSON.stringify(this.codeData));
          }
        } catch (e) {
          this.$error(e.message);
        }
      },
      async initCanvas() {
        if (!this.recruitItem.id) {
          this.$loadingClose();
          return;
        }
        this.initCanvasDraw();
      },
      async initCanvasDraw() {
        setTimeout(() => {
          this.initCanvasDrawDo();
        }, 1000);
      },
      async initCanvasDrawDo() {
        this.$loading('绘制中');
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData1');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      async initCanvas2() {
        if (!this.recruitItem.id) {
          this.$loadingClose();
          return;
        }
        this.initCanvas2Draw();
      },
      initCanvas2Draw() {
        setTimeout(() => {
          this.initCanvas2DrawDo();
        }, 1000);
      },
      async initCanvas2DrawDo() {
        this.$loading('绘制中');
        if (this.shareType === 1) {
            let canvas = await html2canvas(document.getElementById('sharesmall'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          } else {
            let canvas = await html2canvas(document.getElementById('share'), { scale: 2 });
            this.canvasData = canvas.toDataURL('image/jpeg');
          }
          console.log(this.canvasData);
          console.log('this.canvasData2');
          window.scrollTo(0, this.lastScrollLength);
          this.lastScrollLength = 0;
          this.$loadingClose();
          if (this.shareType > 0) {
            this.share(this.shareType);
          }
      },
      onConfirm(id) {
        // 当前选择对象的id
        console.log(id);
        this.shareId = id;
        // 直接分享到微信，不再弹出选择框
        this.doShare(1, id);
      },
      async doShare(shareType, id) {
        try {
          this.$loading("准备分享...");
          this.shareType = shareType;

          // 从列表中找到当前招聘项
          const recruitItem = this.list.find((item) => {
            return item.id * 1 === id * 1;
          });

          if (!recruitItem) {
            this.$loadingClose();
            this.$toast("未找到招聘信息");
            return;
          }

          // 1. 调用接口获取分享追踪令牌
          const tokenResult = await api.get("/api/share/create_share_token", {
            params: {
              recruitDispatchRecordId: recruitItem.recruitDispatchRecordId || "",
              recruitId: recruitItem.id || "",
            },
          });

          // 获取追踪Token
          let trackToken = "";
          if (tokenResult.code === 10000 && tokenResult.data) {
            trackToken = tokenResult.data;
          }
          console.log("分享追踪Token:", trackToken);

          // 检查环境
          const ua = navigator.userAgent;
          const isWxmp = ua.toLowerCase().indexOf('miniprogram') > -1;

          if (shareType === 1) {
            // 微信好友分享
            if (isWxmp) {
              // 小程序环境：跳转到小程序分享页面
              launchMiniProgram({
                appId: "wxbb140f2dced7d207",
                path: `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&shareFlag=true`,
                envVersion: "trial",//release
              });
              this.$loadingClose();
              this.show = false;
              return;
            } else {
              // APP环境：分享小程序卡片
              const miniPath = `subPackages/aboutPost/pages/post_detail/share?id=${id}&shareToken=${trackToken}&IsFromShare=1`;
              const shareObj = {
                shareMedia: 3, // 3-小程序卡片
                shareType: 1, // 1-微信好友
                title: `就业队长招聘${recruitItem.title || ""}`,
                imgUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
                imageUrl: recruitItem.imgUrls && recruitItem.imgUrls[0] ? recruitItem.imgUrls[0] : "",
                userName: "gh_49bd5402050d",
                path: miniPath,
                mType: 0, // 0-正式版
              };
              await shareWithApp(shareObj);
              this.$loadingClose();
              this.show = false;
              return;
            }
          } else if (shareType === 2) {
            // 朋友圈分享 - 使用海报分享流程
            this.recruitItem = recruitItem;
            this.getCodeData();
          }
        } catch (e) {
          this.$loadingClose();
          this.show = false;
          console.error("分享失败:", e);
          this.$toast(e.message || "分享失败");
        }
      },
      async share(index) {
        // try {
        //   if (!this.recruitItem.id) {
        //     return;
        //   }
        //   this.$loading('分享中');
        //   this.$loading('请稍后', 3000);
        //   await this.$store.dispatch('postData', {
        //     url: '/recruit/LeaderPickRecruit',
        //     data: {
        //       Body: {
        //         RecruitSysNo: this.recruitItem.id,
        //         PersonSysNo: this.$store.state.person.PersonSysNo
        //       }
        //     }
        //   });
        //   var findVal = this.list.find(item => {
        //     return (item.id * 1) === (this.recruitItem.id * 1);
        //   });
        //   if (findVal) {
        //     findVal.IsLeaderPick = 1;
        //   }
        //   if (index === 1) {
        //     this.getShareData(this.recruitItem.id);
        //   } else {
        //     try {
        //       await shareWithApp({
        //         imgUrl: this.canvasData,
        //         shareType: index,
        //         shareMedia: 2
        //       });
        //     this.$loadingClose();
        //     } catch (e) {
        //       this.show = false;
        //       this.$toast(e.message);
        //     }
        //   }
        // } catch (e) {
        //   this.$toast(e.message);
        // }
      },
      async getShareData(id) {
        try {
          // 获取分享参数
          if (!this.userName) {
            let res = await this.$store.dispatch('postData', {
              url: '/recruit/GetShareData',
              data: {}
            });
            console.log('getShareData:', res);
            this.userName = res.username;
            this.mType = parseInt(res.mtype);
            this.doShareLittleApp(id);
          } else {
            this.doShareLittleApp(id);
          }
        } catch (e) {
          this.$toast(e);
        }
      },
      async doShareLittleApp(id) {
          let file = convertBase64ToBlob(this.canvasData);
          let formData = new FormData();
          formData.append('folder', 'authen');
          formData.append('file[]', file);
          const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
          };
          let ossRes = await api.post(`/upload/upload-images`, formData, config);
          console.log(ossRes.Data[0].url);
          if (ossRes && ossRes.Data && ossRes.Data.length > 0) {
            // 分享小程序卡片
              let path = '';
              path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.PersonSysNo}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // if (this.$store.state.person.LeaderPersonSysNo) {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&LeaderPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&FromPersonSysNo=${this.$store.state.person.LeaderPersonSysNo}&IsFromShare=1&t=2`;
              // } else {
              //   path = `pages/v2/applicant-job-detail/main?RecruitSysNo=${id}&FromPersonSysNo=${this.$store.state.person.PersonSysNo}&IsFromShare=1&t=2`;
              // }
              let shareObj = {
                shareMedia: 3,
                shareType: 1,
                imgUrl: ossRes.Data[0].url,
                imageUrl: ossRes.Data[0].url,
                link: 'http://www.baidu.com',
                title: `大圣抢班招聘${this.recruitItem.title}`, 
                userName: this.userName,
                path: path,
                mType: this.mType
              };
              try {
              await shareWithApp(shareObj);
              this.$loadingClose();
            } catch (e) {
              this.show = false;
              this.$toast(e.message);
            }
          } else {
            this.$loadingClose();
          }
      }
  }
  };
</script>

<style lang="less" scoped>
  @import '../../assets/css/theme.less';
  .store-detail-top{padding: 12px 15px 25px;}
  .store-detail-top .img-auto{ width: 71px; height: 71px; margin: 0 auto; border-radius:2px; overflow: hidden;}
  .store-detail-top .img-auto img{ width: 100%; height: 100%;}
  .store-detail-top h1{ padding: 10px 0 5px;}

  .store-detail .ds-job-list-box{ margin: 0 0 5px; border: 0; box-shadow: none;}
  .store-detail h2.f16{ padding: 12px 17px; background: #fff;}
  .store-detail h2.f16 b{position: relative}
  .store-detail h2.f16 b::after{ content:''; position: absolute; height: 3px; width: 100%; left: 0; bottom: -13px; background: @primaryColor;}

  .poster-title {
    height: 41px;
    line-height: 41px;
    border-radius: 5px 5px 0 0;
    background: linear-gradient(146deg, rgba(255, 134, 58, 1) 0%, rgba(253, 100, 4, 1) 100%);
  }

  .poster-logo {
    height: 40px;
    width: auto;
    margin-left: 10px;
  }

  .ds-divider-title {
    position: relative;
    overflow: hidden;
  }

  .ds-divider-title::after {
    content: '';
    position: absolute;
    height: 1PX;
    background: @borderColor;
    top: 50%;
    left: 0;
    width: 100%;
  }

  .ds-divider-title > h3, .ds-divider-title > p {
    background: @white;
    z-index: 2;
    position: relative;
  }

  .qr {
    width: 110px;
    height: 110px;
  }

  .poster-img {
    width: 44px;
    height: 44px;
  }

  .ds-list-divider > span {
    background: @bgGray
  }
</style>